export default __webpack_public_path__ + "static/media/Stasis_LE.816cf112.jpg";